/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CarpsaleManagementViewItemResponse } from './CarpsaleManagementViewItemResponse';

export type CarpsaleManagementViewItemResponseApiRespoonse = {
    data?: CarpsaleManagementViewItemResponse;
    status?: CarpsaleManagementViewItemResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace CarpsaleManagementViewItemResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

